export default __webpack_public_path__ + "static/media/Doribac-500-ban.bde2d562.jpg";